import { Col, Container, Row } from "react-bootstrap";
import ImageCard from "./ImageCard";

const ResultImages = ({ photos }) => {
  return (
    <section className="categories mt-3 mt-sm-5 pb-5">
      <Container>
        <Row>
          {photos?.length > 0 && photos?.map((photo) => (
            <ImageCard key={photo.id} photo={photo} />
          ))}

          { photos?.length === 0 && <Col className="text-center text-warning">No Image Found</Col> }
        </Row>
      </Container>
    </section>
  );
};

export default ResultImages;
